

export const isResponseSuccess = (status: number) => {
    return status === 200 || status === 201;
}